var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.75a4e658d63762fd9937f51fe246adef.svg#P';
                    var viewUrl = 'sprites.75a4e658d63762fd9937f51fe246adef.svg#view-P';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 48 48',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };